export default __webpack_public_path__ + "static/media/Blog_Post_1.706a0b73.jpg";